import Header from "./Header";
import Footer from "./Footer";
import { useState, useEffect, use } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles/Booking.css";
import { srLatn } from "date-fns/locale";
import { easeInOut, motion } from "framer-motion";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useRef } from "react";

function Booking() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [numOfPersons, setNumOfPersons] = useState(1);
  const [numOfKids, setNumOfKids] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [showReservationDetails, setShowReservationDetails] = useState(false);
  const [showFinalConfirmation, setShowFinalConfirmation] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [unavailableDates, setUnavailableDates] = useState([]);

  const [error, setError] = useState("");

  const isDateRangeUnavailable = (start, end) => {
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      if (
        unavailableDates.some((unavailableDate) => {
          const date = new Date(unavailableDate);
          return (
            date instanceof Date &&
            !isNaN(date) &&
            date.toDateString() === d.toDateString()
          );
        })
      ) {
        return true;
      }
    }
    return false;
  };
  const handleReservationAndSendEmail = async () => {
    if (!name.trim() || !phone.trim()) {
      alert("Molimo vas da unesete ime i prezime, kao i broj telefona!");
      return;
    }

    if (!startDate || !endDate) {
      alert("Molimo vas da popunite sva obavezna polja!");
      return;
    }

    const adjustedStartDate = new Date(startDate);
    adjustedStartDate.setDate(adjustedStartDate.getDate() + 1);

    const adjustedEndDate = new Date(endDate);
    adjustedEndDate.setDate(adjustedEndDate.getDate() + 1);

    const formattedStartDate = adjustedStartDate.toISOString().split("T")[0];
    const formattedEndDate = adjustedEndDate.toISOString().split("T")[0];

    setShowReservationDetails(false);
    setShowFinalConfirmation(true);

    setTimeout(() => {
      setShowFinalConfirmation(false);
    }, 10000);

    try {
      const response = await axios.post(
        "https://stari-vlah-backend-d6b6be1f828d.herokuapp.com/send-email",
        {
          name,
          phone,
          email,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          numOfPersons,
          numOfKids,
          totalPrice,
        }
      );

      console.log(response.data);
    } catch (error) {
      console.error("Greška pri slanju emaila:", error);
      alert("Došlo je do greške pri slanju emaila.");
    }
  };

  const handleContinueClick = () => {
    if (!startDate || !endDate) {
      alert(
        "Molimo vas da odaberete datume prijave i odjave pre nego što nastavite."
      );
      return;
    }

    if (isDateRangeUnavailable(startDate, endDate)) {
      setError(
        "Jedan ili više datuma u ovom periodu su nedostupni. Molimo vas da izaberete druge datume."
      );
      setTimeout(() => {
        setError("");
      }, 5000);

      return;
    }

    setError("");

    setShowReservationDetails(true);
  };

  const handlePersonChange = (event) => {
    setNumOfPersons(Number(event.target.value));
  };

  const handleKidChange = (event) => {
    setNumOfKids(Number(event.target.value));
  };

  const calculateTotalPrice = () => {
    if (!startDate || !endDate) return 0;

    const timeDiff = endDate - startDate;
    const numberOfNights = Math.ceil(timeDiff / (1000 * 3600 * 24));

    let basePricePerNight = 35;
    if (numOfPersons === 3) {
      basePricePerNight = 38;
    } else if (numOfPersons === 4) {
      basePricePerNight = 40;
    }

    let price = basePricePerNight * numberOfNights;

    if (numberOfNights >= 3) {
      const discountedNights = numberOfNights - 2;
      price =
        basePricePerNight * 2 + basePricePerNight * discountedNights * 0.8;
    }

    return price;
  };

  useEffect(() => {
    const price = calculateTotalPrice();
    setTotalPrice(price);
  }, [startDate, endDate, numOfPersons, numOfKids]);

  useEffect(() => {
    fetchUnavailableDates();
  }, []);

  const fetchUnavailableDates = async () => {
    try {
      const response = await axios.get(
        "https://stari-vlah-strapi-54837937b4c4.herokuapp.com/api/reservations",
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
          },
        }
      );
      const reservations = response.data.data;

      if (Array.isArray(reservations)) {
        const unavailableDates = reservations.flatMap((reservation) => {
          const startDate = new Date(reservation.checkInDate);
          const endDate = new Date(reservation.checkOutDate);

          const dates = [];

          for (let d = startDate; d < endDate; d.setDate(d.getDate() + 1)) {
            dates.push(new Date(d).toISOString().split("T")[0]);
          }
          return dates;
        });

        setUnavailableDates(unavailableDates);
      }
    } catch (error) {
      console.error("Error fetching unavailable dates:", error);
    }
  };
  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (date) {
      const newEndDate = new Date(date);
      newEndDate.setDate(date.getDate() + 2);
      setEndDate(newEndDate);
    }
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const [kidValue, setkidValue] = useState(0);

  const increaseNumOfPersons = () => {
    if (numOfPersons < 4) setNumOfPersons(numOfPersons + 1);
  };

  const decreaseNumOfPersons = () => {
    if (numOfPersons > 0) setNumOfPersons(numOfPersons - 1);
  };

  const increaseNumOfKidsValue = () => {
    if (numOfKids < 3) setNumOfKids(numOfKids + 1);
  };

  const decreaseNumOfKidsValue = () => {
    if (numOfKids > 0) setNumOfKids(numOfKids - 1);
  };

  const [isGuestNumberOpen, setIsGuestNumberOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If clicked outside the dropdown, close it
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsGuestNumberOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [showGuestCount, setShowGuestCount] = useState(false);

  const handleNumOfGuestsClick = () => {
    setIsGuestNumberOpen(!isGuestNumberOpen);
    setShowGuestCount(true);
  };

  return (
    <>
      <Helmet>
        <title>Rezervisite smestaj - Apartman Stari Vlah Zlatibor</title>
        <meta
          name="description"
          content="Rezervišite Apartman Stari Vlah Zlatibor brzo i jednostavno. Garantujemo najbolje cene i savršen smeštaj za vaš odmor na Zlatiboru!"
        />

        <meta
          name="keywords"
          content="rezervacija apartmana Zlatibor, smeštaj Zlatibor online rezervacija, apartman Stari Vlah rezervacija, povoljan apartman Zlatibor, smeštaj Zlatibor cene, noćenje Zlatibor, najbolji apartmani Zlatibor, bookiranje apartmana Zlatibor"
        />
        <script type="application/ld+json">
          {`
            {
            "@context": "http://schema.org",
                "@type": "Hotel",
              "name": "Apartman Stari Vlah",
              "url": "https://starivlahzlatibor.rs/booking",
                "address": {
                  "@type": "PostalAddress",
              "streetAddress": "Nikole Altomanovića 6",
              "addressLocality": "Zlatibor",
                "addressCountry": "Serbia"
                },
                  "priceRange": "30 EUR",
              "telephone": "+3816836736",
                "priceCurrency": "EUR",
              "checkinTime": "14:00",
            "checkoutTime": "11:00"
              }
            `}
        </script>
      </Helmet>
      <Header />
      <div className="mainBookingDiv">
        <div className="bookYourStayDiv">
          <img
            src="/images/zlatiborPanorama.webp"
            className="panoramaImg"
            loading="lazy"
            alt="Fotografija panorame Zlatibora - Zlatibor smeštaj Stari Vlah"
          ></img>
          <motion.h2
            className="sendRequestHeader"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}
          >
            Rezervišite svoj boravak u Apartmanu Stari Vlah na Zlatiboru
          </motion.h2>
          <div className="chooseDetailsDiv">
            <motion.div
              className="reservationColumnDiv"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <DatePicker
                selected={startDate}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                minDate={new Date()}
                dateFormat="dd/MM/yyyy"
                placeholderText="Datum prijave"
                className="datePicker"
                locale={srLatn}
                onChange={handleStartDateChange}
                excludeDates={unavailableDates.map((date) => new Date(date))}
              />

              <DatePicker
                selected={endDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={
                  startDate
                    ? new Date(startDate.getTime() + 2 * 24 * 60 * 60 * 1000)
                    : new Date()
                }
                dateFormat="dd/MM/yyyy"
                placeholderText="Datum odjave"
                className="datePicker"
                locale={srLatn}
                onChange={handleEndDateChange}
                disabled={!startDate}
                excludeDates={unavailableDates.map((date) => new Date(date))}
              />
              <div className="totalPersonsDiv" onClick={handleNumOfGuestsClick}>
                <p className="numberOfPersonsParagraph">
                  {showGuestCount
                    ? `${numOfPersons + numOfKids} ${
                        numOfPersons + numOfKids === 1 ? "gost" : "gosta"
                      }`
                    : "Broj gostiju"}
                </p>
                <img src="/images/user.webp" className="userInputIcon" />
              </div>
              {isGuestNumberOpen && (
                <div className="chooseCapacityDiv" ref={dropdownRef}>
                  <div className="adultCapacityDiv">
                    <p className="capacityInfoParagraph">Odrasli</p>
                    <div className="capacityController">
                      <button
                        onClick={decreaseNumOfPersons}
                        disabled={numOfPersons === 1}
                        className="numberBtn"
                      >
                        <img
                          src="/images/minusGray.webp"
                          className="minusImg"
                        />
                      </button>
                      <input
                        type="number"
                        readOnly
                        className="personInput"
                        value={numOfPersons}
                        onChange={handlePersonChange}
                      />
                      <button
                        onClick={increaseNumOfPersons}
                        disabled={numOfPersons === 4}
                        className="numberBtn"
                      >
                        <img src="/images/plusGray.webp" className="minusImg" />
                      </button>
                    </div>
                  </div>
                  <div className="kidCapacityDiv">
                    <div className="kidsAgeDiv">
                      <p className="capacityInfoParagraph">Deca</p>
                      <p className="kidsAgeParagraph">Od 0 do 14 godina</p>
                    </div>

                    <div className="capacityController">
                      <button
                        onClick={decreaseNumOfKidsValue}
                        disabled={numOfKids === 0}
                        className="numberBtn"
                      >
                        <img
                          src="/images/minusGray.webp"
                          className="minusImg"
                        />
                      </button>
                      <input
                        type="number"
                        value={numOfKids}
                        readOnly
                        className="personInput"
                      />
                      <button
                        onClick={increaseNumOfKidsValue}
                        disabled={numOfKids === 3}
                        className="numberBtn"
                      >
                        <img src="/images/plusGray.webp" className="minusImg" />
                      </button>
                    </div>
                  </div>
                  <div className="petCapacityDiv">
                    <input type="checkBox" className="petCheck" />
                    <div className="petAgeDiv">
                      <p className="capacityInfoParagraph">Kućni ljubimci</p>
                      <p className="kidsAgeParagraph">
                        Moguća naplata naknade za čišćenje
                      </p>
                    </div>
                  </div>
                  <div className="finishBtnDiv">
                    <button
                      className="finishBtn"
                      onClick={() => setIsGuestNumberOpen(!isGuestNumberOpen)}
                    >
                      Gotovo
                    </button>
                  </div>
                </div>
              )}
            </motion.div>

            <motion.div
              className="totalPriceDiv"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <p className="totalPriceParagraph">Ukupna cena smeštaja: </p>
              <p className="totalPriceHeader">{totalPrice.toFixed(2)} EUR</p>
            </motion.div>
            <motion.button
              className="continueWithReservation"
              onClick={handleContinueClick}
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                type: "spring",
                stiffness: 100,
                damping: 7,
                delay: 1.4,
              }}
            >
              Dovrši rezervaciju
            </motion.button>
          </div>
        </div>

        <div className="priceInformationDiv">
          <motion.img
            src="/images/pineTree.jpg"
            className="pineTreeImg"
            alt="Slika smestaj Zlatibor povoljno"
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1 }}
            viewport={{ once: true, amount: 0.5 }}
          />
          <div>
            {[
              "Cena noćenja u apartmanu zavisi od broja noćenja, datuma boravka, kao i od broja osoba koje borave u smeštaju.",
              "Osnovna cena noćenja iznosi 35e za dve odrasle osobe, a za decu uzrasta do 14 godina boravak je besplatan.",
              "Minimalan broj noćenja je 2, a za više od 3 noćenja gosti ostvaruju popust u iznosu od 20% na svako naredno noćenje.",

              "Popunjavanjem forme iznad dobićete tačnu cenu vašeg boravka, a onda nam možete poslati zahtev za rezervaciju.",
            ].map((text, index) => (
              <motion.p
                key={index}
                className={`priceParagraph${index + 1}`}
                initial={{ x: -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                viewport={{ once: true, amount: 0.5 }}
              >
                🔹{text}
              </motion.p>
            ))}
          </div>
        </div>
        <Footer />
        {showReservationDetails && (
          <motion.div
            className="reservationDetailsOuterDiv"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
          >
            <div className="reservationDetailsInnerDiv">
              <h3 className="reservationConfirmationHeader">
                Potvrda rezervacije
              </h3>
              <div className="reservationDetailsConfirmationDiv">
                <p className="reservationDetailsConfirmation">Datum prijave:</p>
                <p className="reservationDetailsConfirmationInformation">
                  {" "}
                  {startDate ? startDate.toLocaleDateString("sr-RS") : ""}
                </p>
              </div>
              <div className="reservationDetailsConfirmationDiv">
                <p className="reservationDetailsConfirmation">Datum odjave:</p>
                <p className="reservationDetailsConfirmationInformation">
                  {" "}
                  {endDate ? endDate.toLocaleDateString("sr-RS") : ""}
                </p>
              </div>
              <div className="reservationDetailsConfirmationDiv">
                <p className="reservationDetailsConfirmation">Broj odraslih:</p>
                <p className="reservationDetailsConfirmationInformation">
                  {" "}
                  {numOfPersons}
                </p>
              </div>
              <div className="reservationDetailsConfirmationDiv">
                <p className="reservationDetailsConfirmation">Broj dece:</p>
                <p className="reservationDetailsConfirmationInformation">
                  {" "}
                  {numOfKids}
                </p>
              </div>
              <div className="reservationDetailsConfirmationDiv">
                <p className="reservationDetailsConfirmation">Ukupna cena:</p>
                <p className="reservationDetailsConfirmationInformation">
                  {" "}
                  {totalPrice}e
                </p>
              </div>
              <p className="reservationDetailsConfirmationParagraph">
                Molimo Vas da popunite polja ispod kako biste dovršili
                rezervaciju.
              </p>

              <input
                type="text"
                placeholder="Ime i prezime"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="reservationConfirmationInput"
                required
              />

              <input
                type="email"
                placeholder="Email"
                className="reservationConfirmationInput"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="tel"
                placeholder="Broj telefona"
                className="reservationConfirmationInput"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              <div className="finalButtonsDiv">
                <button
                  className="closeReservationModalBtn"
                  onClick={() => setShowReservationDetails(false)}
                >
                  Odustani
                </button>
                <button
                  className="finalReservationBtn"
                  onClick={handleReservationAndSendEmail}
                >
                  Rezerviši
                </button>
              </div>
            </div>
          </motion.div>
        )}

        {showFinalConfirmation && (
          <motion.div
            className="confirmationDiv"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <p className="confirmationText">
              ✅ Vaša rezervacija je uspešno poslata! <br></br>Osoblje apartmana
              će Vas uskoro kontaktirati.
            </p>
          </motion.div>
        )}
        {error && (
          <motion.div
            className="unavailableDatesDiv"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <p className="confirmationText">
              &#9888;&#65039; Jedan ili više datuma u ovom periodu su
              nedostupni. Molimo vas da izaberete druge datume.
            </p>
          </motion.div>
        )}
      </div>
    </>
  );
}

export default Booking;
